import React, { Component } from 'react';

class IconInfo extends Component
{
    render = () => {
        return (
            <svg className="icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 283.465 283.465" enableBackground="new 0 0 283.465 283.465"
	            xmlSpace="preserve">
            <rect fill="#94BC4F" width="283.465" height="283.465"/>
            <g>
	            <defs>
		            <rect id="SVGID_1_" width="283.465" height="283.465"/>
	            </defs>
	            <clipPath id="SVGID_2_">
		            <use xlinkHref="#SVGID_1_"  overflow="visible"/>
	            </clipPath>
                <path clipPath="url(#SVGID_2_)" fill="#FFFFFF" d="M131.004,191.128c0,6.268,5.081,11.35,11.35,11.35s11.351-5.082,11.351-11.35
		            c0-6.27-5.082-11.351-11.351-11.351S131.004,184.858,131.004,191.128 M168.271,138.21c4.694-6.203,8.214-12.572,8.214-20.954
		            c0-21.289-16.427-33.525-35.369-33.525c-19.445,0-35.202,12.739-35.202,33.525h21.792c0-7.711,4.526-13.913,13.41-13.913
		            c8.381,0,13.578,5.867,13.578,13.745c0,3.688-2.18,7.711-4.861,11.232l-12.404,15.924c-4.358,5.699-6.37,10.226-6.37,17.434v5.029
		            h21.792v-3.521c0-2.85,1.341-6.37,3.018-8.549L168.271,138.21z M224.952,141.732c0,45.961-37.26,83.219-83.219,83.219
		            c-45.961,0-83.22-37.258-83.22-83.219s37.259-83.219,83.22-83.219C187.692,58.514,224.952,95.771,224.952,141.732 M241.534,141.732
		            c0-55.119-44.684-99.802-99.801-99.802c-55.119,0-99.802,44.683-99.802,99.802c0,55.119,44.683,99.801,99.802,99.801
		            C196.851,241.533,241.534,196.852,241.534,141.732"/>
            </g>
            </svg>
        );
    }
}

export default IconInfo;


// WEBPACK FOOTER //
// ./src/components/App/IconInfo.js